import React from 'react';
import Layout from '../components/Layout';


const PrivacyPage = () => {
    const sections = [{
        title: "Introduction",
        content: "At MVPsec.ai, we are committed to protecting the privacy and security of our customers and website visitors. This Privacy Policy outlines how we collect, use, protect, and disclose your information when you use our website and services.",
      },
      {
          title: "Information We Collect",
          content: `We may collect personal information that you provide to us, such as your name, email address, and payment information. We also collect non-personal information, such as browsing data and how you use our website.`
      },
      {
          title: "Use of Information",
          content: "The information we collect may be used to",
          list:[
            "Provide, maintain, and improve our services",
            "Process transactions and send related information, including confirmations and invoices",
            "Send you technical notices, updates, security alerts, and support messages",
            "Respond to your comments, questions, and requests"
          ]
      },
      {
          title: "Sharing of Information",
          content: "We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information except in the following cases:",
          list:
          [
            "To comply with the law or in response to a subpoena, court order, or other legal process",
            "To protect the rights, property, or safety of MVPsec.ai, our customers, or others",
            "To our trusted services providers who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential"
            ]
      },
      {
          title: "Data Security",
          content: `We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the Internet or method of electronic storage is 100% secure.`
      },
      {
          title: "Changes to Our Privacy Policy",
          content: `We may update this Privacy Policy to reflect changes to our information practices. We will notify you by email (sent to the e-mail address specified in your account) or by means of a notice on this website prior to the change becoming effective.`
      },
      {
          title: "Contact Us",
          content: `If you have any questions about this Privacy Policy, please contact us at [insert contact information]`
      }
    ];

    return (
        <Layout>
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-primary-900 via-secondary-900 to-dark-950 py-20">
            <div className="container mx-auto px-4 text-center">
              <h1 className="text-6xl font-display font-bold bg-gradient-to-r from-white via-primary-200 to-accent-300 bg-clip-text text-transparent mb-6">
                Privacy Policy
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                Your privacy and security are our top priorities.
              </p>
            </div>
          </div>

          {/* Privacy Content */}
          <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 dark:from-dark-950 dark:to-dark-900 py-16">
            <div className="container mx-auto px-4">
              <div className="space-y-8">
                {sections.map((section, index) => (
                  <div key={index} className="bg-white dark:bg-dark-800 p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100 dark:border-gray-800 hover:border-primary-200 dark:hover:border-primary-800 transform hover:scale-105">
                    <div className="text-center">
                      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                        {section.title}
                      </h2>
                      <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-4">
                        {section.content}
                      </p>
                      {section.list && (
                        <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400 text-left max-w-3xl mx-auto">
                          {section.list.map((item, listItemIndex) => (
                            <li key={listItemIndex}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Layout>
      );
    };
export default PrivacyPage;